module.exports = __webpack_public_path__ + "static/media/searchIcon.cd3555e4.svg";